import React, {useContext, useEffect, useState} from "react";
import axios from 'axios'
import {GlobalContext} from "../../contexts/context";

export const useAuthenticateUser = () => {
    const context = useContext(GlobalContext);
    const [loading, setLoading] = useState(false);
    const [content, setContent] = useState({});
    let mounted = true;
    const handleAuthenticate = async (req) => {
        setLoading(true);
        try {
            let data;
            if(process.env.NODE_ENV === "development")
                data = await axios.get(`${context.applicationState.apiUrl}/api/authsession.aspx?server=${req.clientId}&userName=${req.username}&userPass=${req.password}`);
            else
                data = await axios.get(`${context.applicationState.apiUrl}/api/authsession.aspx?server=${req.clientId}&userName=${req.username}&userPass=${req.password}`, {withCredentials: true});
            if (mounted) {
                if (data.status === 200) {
                    if (data.data === "OK") {
                        setContent({
                            data: data.data,
                            message: "Login successful",
                            hasError: false
                        });
                    } else {
                        setContent({
                            data: null,
                            message: data.data,
                            hasError: true
                        });
                    }
                } else {
                    setContent({
                        data: null,
                        message: "An unknown error occurred while attempting to fetch items.",
                        hasError: true
                    })
                }
                setLoading(false)
            }
        } catch(err){
            setContent({
                data: null,
                message: "An unknown error occurred while attempting to fetch items.",
                hasError: true
            })
            setLoading(false)
        }
    };

    useEffect(() => {
        return () => {
            mounted = false;
        };
    }, []);

    return {loading, content, handleAuthenticate};
};
